import * as jspm from './jspm.js';
import * as skypack from './skypack.js';
import * as jsdelivr from './jsdelivr.js';
import * as unpkg from './unpkg.js';
import * as nodemodules from './nodemodules.js';
import * as node from './node.js';
export const defaultProviders = {
    jsdelivr,
    jspm,
    node,
    nodemodules,
    skypack,
    unpkg
};
export function getProvider(name, providers = defaultProviders) {
    const provider = providers[name];
    if (provider)
        return provider;
    throw new Error('No ' + name + ' provider is defined.');
}
//# sourceMappingURL=index.js.map